const animationDuration = 600;
const animationEasing = 'swing';

document.addEventListener("DOMContentLoaded", () => {
    const checkButtons = document.querySelectorAll('.js-meter-check');

    checkButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();

            if(e.target.disabled){
                return;
            }

            const parentContainer = this.closest('[data-meter-id]')
            const meterId = parentContainer.dataset.meterId;
            const container = document.querySelector(`[data-meter-container="${meterId}"]`);

            if (!container) return;

            const uncheckedCircle = container.querySelector('.meter-unchecked');
            const checkedCircle = container.querySelector('.meter-checked');
            const button = this;

            // Проверяем, отмечено ли уже
            const isChecked = container.dataset.meterChecked === 'true';

            if (isChecked) {
                // Отмена проверки
                container.dataset.meterChecked = 'false';

                // Показываем пустой кружок
                uncheckedCircle.classList.remove('tw:hidden');
                uncheckedCircle.classList.add('tw:flex');

                // Скрываем кружок с галочкой
                checkedCircle.classList.remove('tw:flex');
                checkedCircle.classList.add('tw:hidden');

                // Меняем текст кнопки
                button.innerHTML = '<i class="fas fa-check-circle tw:mr-2"></i>Проверено';
                button.classList.remove('tw:bg-green-600', 'tw:hover:bg-green-700');
                button.classList.add('tw:bg-blue-600', 'tw:hover:bg-blue-700');

            } else {
                // Отметить как проверенное
                container.dataset.meterChecked = 'true';

                // Скрываем пустой кружок
                uncheckedCircle.classList.remove('tw:flex');
                uncheckedCircle.classList.add('tw:hidden');

                // Показываем кружок с галочкой
                checkedCircle.classList.remove('tw:hidden');
                checkedCircle.classList.add('tw:flex');

                // Меняем текст кнопки
                button.innerHTML = '<i class="fas fa-undo tw:mr-2"></i>Не проверено';
                button.classList.remove('tw:bg-blue-600', 'tw:hover:bg-blue-700');
                button.classList.add('tw:bg-green-600', 'tw:hover:bg-green-700');

                scrollToMeter(container);
            }
        });
    });
});

function scrollToMeter(container) {
    const $box = $(container.closest('[data-accordion=".js-accordion-meter"]'));
    const headerHeight = 100;

    // Устанавливаем длительность анимации
    $box.accordion("option", "animate", {
        duration: animationDuration,
        easing: animationEasing
    });

    // Если аккордеон не свернут
    const activeHeader = $box.accordion("option", "active");
    if (activeHeader !== false) {
        // Сворачиваем аккордеон
        $box.accordion("option", "active", false);
    }

    smoothScrollTo(container, headerHeight);
}

function smoothScrollTo(element, offset = 0) {
    const targetPosition = $(element).offset().top - offset;

    $('html, body').animate({
        scrollTop: targetPosition
    }, animationDuration, animationEasing);
}
